import React from "react";
import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import { SourceFlowHead } from "@sourceflow-uk/sourceflow-head";
import metaObject from "@/.sourceflow/metadata.json";
import sourceflowEnums from "@/sourceflow.enums";
import SubBanner from "@/components/SubBanner";
import FooterWave from "@/public/site-assets/svg/footer-wave.svg";
import SimpleFormWithColumn from "@/components/SimpleFormWithColumn";
import LocationDetails from "@/components/LocationDetails";
import AccordionFAQ from "@/components/AccordionFAQ";
import WaveIcon1 from "@/public/site-assets/svg/faq-wave-1.svg";

import {
    Container,
} from 'reactstrap';

import { router } from "@/routes";
import { useLocale } from "@/hooks/useLocale";
/**
 *
 * @param global
 * @param meta
 * @returns {JSX.Element}
 * @constructor
 */
export default function IndividualContactUs({
    global,
    meta,
    page,
    contact_us_page_faq
}) {
    const locale = useLocale();

    return (
        <>
            <SourceFlowHead
                metaObject={metaObject}
                title={meta.title}
                description={meta.description}
                canonical={meta.canonical}
            />
            <div className="bg-light-white">
                <SubBanner
                    global={global}
                    pathPrefix={`${page.url_slug}.contact_us.location.page.sub_banner`}
                    heading={`Contact the ${page.title} team`}
                    content={<p>Amet eget a mauris quis dignissim lacus lectus nec. Suspendisse facilisis ipsum fermentum viverra tincidunt viverra felis vulputate amet.</p>}
                    breadcrumb_title={<><span><a href="/contact-us">Contact</a></span><span className="active">{page.title}</span></>}
                    wave_color={`light-grey`}
                />
                <LocationDetails
                    global={global}
                    pathPrefix={`${page.url_slug}.contact_us.location.page.location_details`}
                    post={page}
                />
                <section className="bg-white">
                    <SimpleFormWithColumn
                        global={global}
                        pathPrefix={`${page.url_slug}.contact_us.location.page.simple_form_with_column`}
                        heading={``}
                        content={
                            <div dangerouslySetInnerHTML={{ __html: page.content }} />
                        }
                        formId={`${page?.form}`}
                        imageURL={``}
                        page_slug={`contact-us/${page.url_slug}`}
                        social_share={true}
                        share_heading={`Contact our ${page.title} office:`}

                    />
                </section>
                {page.faq?.length >= 1 && (
                    <>
                        <div>
                            <WaveIcon1 />
                        </div>
                        <AccordionFAQ
                            global={global}
                            pathPrefix={`${page.url_slug}.contact_us.location.page.accordion_faq`}
                            post={page.faq}
                        />
                        <div className="yellow footer">
                            <FooterWave />
                        </div>
                    </>
                )}
            </div>
        </>
    );
}

/**
 *
 * @returns {Promise<{props: {meta: {description: string, canonical: string, title: string}, jobs: *, global}}>}
 */
export async function getStaticProps({ params }) {

    const page = (await Collection("locations")).getJsonItem(
        params.url_slug,
        "url_slug"
    );
    const contact_us_page_faq = (await Collection(`contact_us_page_faq`)).getItems()


    const global = (await Global()).toJson();

    const routerKey = {
        en: router["contact_us.item"]["en"].replace("[url_slug]", page.url_slug),
    };

    return {
        props: {
            global,
            meta: {
                title: `${page.title} | Tradewind Recruitment`,
                description: `${sourceflowEnums.seo.genericDescription}`,
                // canonical: sourceflowEnums.seo.baseURL,
                canonical: `${sourceflowEnums.seo.baseURL}${routerKey.en}`,
                // alternate: { link: router[routerKey]["en"], lang: "en" },
            },
            page,
            contact_us_page_faq
        },
    };
}


export async function getStaticPaths() {
    const pagePaths = (await Collection('locations')).getPaths('url_slug');
    // const paths = (await Collection("locations")).getItems();

    return {
        paths: pagePaths,
        fallback: false,
    };
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflowtext
// https://github.com/sourceflow-uk/components/pkgs/npm/job-search